import { Card, Col, Radio, Row, Spin } from "antd"
import { Line, TinyArea, TinyLine } from '@ant-design/plots';
import { DemoLine } from "../components/molecules/DemoLine";
import { useFetch } from "../hooks/useFetch";
import { Link } from "react-router-dom";
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import PercentageCustom from "../components/atoms/PercentageCustom";

export const Market = () => {

    const { data: dailyData, isLoading } = useFetch(`${process.env.REACT_APP_API}/market/last72hours`, {}, []);


    const config = {
        height: 30,
        color: 'SlateGray',
        autoFit: true,
        smooth: true,
        smooth: true,
        yAxis: {
			min: 10000
		},
        animation: {
            appear: {
              animation: 'path-in',
              duration: 1000,
            },
          },
    };

    return <div className="general-container">
        <h2 style={{ textAlign: 'center', marginBottom: '5px', color:'var(--header-grey)' }}>Cotizaciones por metal</h2>  
        <p style={{ textAlign: 'center', marginBottom: '10px', color:'var(--header-grey)' }}>Incremento últimas 72 horas</p>      
        
        {!isLoading ?
           <>
            {dailyData.length > 0 ? 
        
            <div style={{ marginTop: '20px' }}>
            {dailyData.map((m) => {
                const valuesArray = m?.last72hours.map((data) => data.value);

                return <Link to={`/cotizaciones/${m.metal}`}>

                    <Row key={m.metal} style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '10px' }}>
                        <Col span={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                        >
                            <div style={{ backgroundColor: 'ivory', border: '.5px var(--dark-accent) solid', width: '80px', height: '80px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderRadius: '15px', margin: '10px 0px', paddingTop: '5px' }}>
                                <div style={{ border: '3px solid var(--dark-accent)', borderRadius: '5px', height: '35px', width: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span style={{ fontWeight: '700', color: 'var(--dark-accent)' }}>{m.metal}</span>
                                </div>
                                <div style={{ margin: '5px 0px', height: '3px', width: '15px', backgroundColor: 'var(--dark-accent)' }}></div>
                                <b style={{ color: 'var(--dark-accent)' }}>{m.metalName}</b>
                            </div>
                        </Col>
                        <Col span={17}>
                            <div style={{ backgroundColor: 'ghostwhite', border: '1px lightgrey solid', width: 'auto', height: '80px', display: 'flex', flexDirection: 'column', borderRadius: '15px', margin: '10px 0px', paddingTop: '5px' }}>

                                <div style={{ marginLeft: '10px', display:'flex', justifyContent:'space-around' }} >
                                    <div style={{ fontSize: '15px', color: 'var(--header-grey)', marginBottom:'15px' }}><b>{m.currentQuote.value}</b>€<small> / onza</small></div>
                                    <small><b><PercentageCustom increment={m.increment}/></b></small>
                                </div>

                                <div style={{ width: '100%' }}>
                                    <TinyLine {...config}
                                    data={valuesArray}

                                    />
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Link>

            })}
        </div> 
        :
        <Card><div style={{ textAlign: 'center', fontWeight: 600, color: 'grey' }}>No hay datos de cotización</div></Card>}
        </>
        : 
        <div style={{height:'300px', display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Spin/>
        </div>
    } 
    </div>
}